export const planBenefits = [
  'Fechamento contábil',
  'Fechamento fiscal',
  'Envio das guias de impostos',
  'Certidões negativas',
  'Checklist de auditoria',
  'Acesso exclusivo ao app Hubs',
  'Atendimento humanizado',
  'Acesso ao clube de vantagens',
  'Videochamada com especialistas',
  'E muito mais!',
]

export const digitalCertificateBenefits = ['Certificado e-CPF', 'Certificado e-CNPJ']

export const meiDescription = {
  name: 'MEI',
  description: 'Faturamento anual até R$ 81 mil',
}

export const simplesNacionalDescription = {
  name: 'Simples Nacional',
  description: 'Faturamento anual até R$ 4,8 milhões',
}

export const lucroPresumidoDescription = {
  name: 'Lucro Presumido',
  description: 'Sem limite de faturamento',
}

export const lucroRealDescription = {
  name: 'Lucro Real',
  description: 'Sem limite de faturamento',
}

export const digitalCertificateDescription = {
  name: 'Certificado Digital',
  description: 'Emita seu certificado digital',
}
